export const DescriptionBoxMessages = {
  labels: {
    print: {
      id: 'descriptionBox.Label.Print',
      defaultMessage: 'Print',
    },
  },
};
